import React, { useState, useEffect } from "react";
import ApplicationContent from "../ApplicationContent";
import UniversitiesShortlist from "./UniversitiesShortlist";
import VisaContent from "../VisaContent";
import CourseShortlist from "./CourseShortlist";

function UniversityCourseShortlisted(props) {
  const [toggleState, setToggleState] = useState(1);
  const [totalTabs, setTotalTabs] = useState([
    {
      tab: 1,
      tabText: "Shortlisted Univercities",
    },
    {
      tab: 2,
      tabText: "Shortlisted Courses",
    },
  ]);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const renderTabs = totalTabs.map((perTab) => {
    return (
      <button
        className={toggleState === perTab.tab ? "tabs1 active-tabs1" : "tabs1"}
        onClick={() => toggleTab(perTab.tab)}
        key={Math.random()}
      >
        {perTab.tabText}
      </button>
    );
  });
  return (
    <div className="application_visa_container">
      <div className="">
        <div className="bloc-tabs1">{renderTabs}</div>
      </div>
      <div className="content-tabs">
        <div
          className={toggleState === 1 ? "content  active-content" : "content"}
        >
          <UniversitiesShortlist />
        </div>
        <div
          className={toggleState === 2 ? "content  active-content" : "content"}
        >
          <CourseShortlist />
        </div>

        <hr />
      </div>
    </div>
  );
}

export default UniversityCourseShortlisted;
